export default __webpack_public_path__ + "static/media/no-program.ae28d0de.svg";